import { CompaniesByUserModelAPI } from '../../../../models';
import { getCompaniesByUserAdapters } from '../../Adapters';
import { requests } from '../apiAgent';

export const CompaniesAPI = {
    getCompaniesByUser: (userId: number) => {
        return requests
            .get('/jerusalem/api/v2.0.0/companies/' + userId)
            .then((response: CompaniesByUserModelAPI[]) =>
                getCompaniesByUserAdapters(response)
            );
    },
};
